import React from 'react';
import Form from 'react-bootstrap/Form';

function Checkbox(props: any) {
    const handleChange = (value: any) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    return(
        <Form.Check
            type={"checkbox"}
            checked={props.value != undefined ? props.value : (props.defaultValue != undefined ? props.defaultValue : false)}
            disabled={props.disabled}
            name={props.name}
            label={props.title}
            onChange={(evt) => handleChange(evt.target.checked)}
        />
    );
}

export default Checkbox;